module.exports = __webpack_public_path__ + "static/img/fpq.2ec4d81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fpq.jpg
// module id = e9Uk
// module chunks = 1